export default from './default-desktop-layout';



// WEBPACK FOOTER //
// ./app/components/default-desktop-layout/index.js